import { createFileRoute, redirect } from "@tanstack/react-router";

// The app has no public landing page: admin-v2 is always gated. `/` only
// exists because it must stay a valid route - it is the OIDC
// `post_logout_redirect_uri` (see `auth/userManager.ts`) - so a visit here
// (including the post-logout bounce) is forwarded straight to the dashboard,
// where `_authenticated`'s `AuthGate` takes over and redirects an anonymous
// visitor on to Keycloak. `replace: true` keeps `/` out of history so the
// back button does not bounce between the two.
export const Route = createFileRoute("/")({
  beforeLoad: () => {
    throw redirect({ to: "/dashboard", replace: true });
  },
});
